import { useState } from "react";
import axios from "axios";
import "../../styles/components/forms.css";

export default function ProfileSubmission() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    imageUrl: "",
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const form = new FormData();
      form.append("name", formData.name);
      form.append("email", formData.email);
      form.append("phone", formData.phone);

      if (selectedFile) {
        form.append("media", selectedFile);
      }

      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/mailerlite/newapp`,
        form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setMessage(
        "Takk for at du meldte deg på! Du vil få en invitasjonslink i e-posten din for å få tilgang til appen så snart som mulig."
      );
      setFormData({
        name: "",
        email: "",
        phone: "",
        imageUrl: "",
      });
      setSelectedFile(null);
    } catch (error) {
      setError("Kunne ikke melde deg på. Prøv igjen.");
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="profile-submission-container">
      <h1>Velkommen til 1 mnd gratis bruk av Løpeglad</h1>
      <p className="intro-text">
        Her får du mange ulike økter for alle nivå og program du kan følge mot mål.
        Du vil ikke bli trukket noe automatisk etter endt periode, men du får en mail med oppfordring til å fortsette.     
      </p>

      <form onSubmit={handleSubmit} className="profile-form">
        <div className="form-group">
          <label htmlFor="name">Fullt navn *</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">E-post *</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="phone">Telefonnummer</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
          />
        </div>

        {/* <div className="file-upload">
                    <label className="upload-button">
                        <i className="fas fa-cloud-upload-alt"></i>
                        Upload Video
                        <input
                            type="file"
                            accept="video/*"
                            onChange={handleFileSelect}
                            style={{ display: 'none' }}
                            multiple
                        />
                    </label>
                    {files.map((file, index) => (
                        <div key={index} className="selected-file">
                            <span>{file.name}</span>
                            <button
                                type="button"
                                className="remove-file"
                                onClick={() => removeFile(index)}
                            >
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                    ))}
                </div> */}

        {/* <div className="form-group"> */}
        {/* <label>Last opp bilde av nåværende app-abonnement her</label>
        <div className="file-upload">
          <label className="upload-button">
            <i className="fas fa-cloud-upload-alt"></i>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="file-input"
              style={{ display: "none" }}
            />
            {selectedFile ? "Change Image" : "Upload Image"}
          </label>
          {selectedFile && (
            <div className="selected-file">
              <span>{selectedFile.name}</span>
              <button
                type="button"
                className="remove-file"
                onClick={() => setSelectedFile(null)}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
          )}
        </div> */}
        {/* </div> */}
        <div className="app-links" style={{ display: 'flex', columnGap: '5rem', marginBottom: '1rem', marginTop: '1rem', justifyContent: 'center' }}>
          <a
            href="https://play.google.com/store/apps/details?id=com.app.lopeglad&pcampaignid=web_share"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Hent på Google Play"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Google_Play_2022_logo.svg/1024px-Google_Play_2022_logo.svg.png"
              alt="Hent den på Google Play"
              style={{ height: '22px', width: 'auto', display: 'block' }}
            />
          </a>
          <a
            href="https://apps.apple.com/no/app/l%C3%B8peglad/id6741588236?l=nb"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Hent på App Store"
          >
            <img
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              alt="Last ned på App Store"
              style={{ height: '26px', width: 'auto', display: 'block' }}
            />
          </a>
        </div>

        <button type="submit" className="submit-button" disabled={loading}>
          {loading ? "Sender inn..." : "Meld deg på"}
        </button>
      </form>

      {message && <div className="success-message">{message}</div>}
      {error && <div className="error-message">{error}</div>}
    </div>
  );
}
